'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _immutable = require('immutable');

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _AppConfigContainer = require('./AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STEPS = null;
var STEP_KEYSEQ = null;

/*
 *  Formats all steps like so:
 *
 *  STEPS = {
 *     validate: {
 *       handler: Validate,
 *       props: {...}
 *     },
 *  }
 *
 */

function _formatConfig(steps) {
  // A few opts are top-level and don't need to be on every step (aka
  // a step can't overwrite them).
  var defaultOpts = _AppConfigContainer2.default.get().delete('onComplete');
  return steps.map(function (step) {
    // Long form to override config defaults
    if ((typeof step === 'undefined' ? 'undefined' : _typeof(step)) === 'object') {
      return defaultOpts.merge(step);
    }

    // shorthand {key: Handler}
    return defaultOpts.merge({
      handler: step
    });
  });
}

var StepsConfigContainer = {
  get: function get() {
    return STEPS;
  },
  getKeys: function getKeys() {
    return STEP_KEYSEQ;
  },
  set: function set(steps) {
    if (_immutable.OrderedMap.isOrderedMap(steps)) {
      STEPS = _formatConfig(steps);
    } else {
      (0, _invariant2.default)(steps.constructor === Object, 'StepsConfigContainer: Steps must be an Object or OrderedMap.' + ' Found `%s`', steps.constructor.name);
      STEPS = _formatConfig((0, _immutable.OrderedMap)(steps));
    }

    STEP_KEYSEQ = STEPS.keySeq();
    return STEPS;
  }
};

exports.default = StepsConfigContainer;
module.exports = exports['default'];